import { useGetCarousel } from "./utils/useGetCarousel";
import { withApolloProvider } from "providers/ApolloClientProvider";
import { GRAPHQL_CMS_BASE_URL } from "constants/endpoints";
import { Carousel } from "components/UI/molecules";
import { Skeleton } from "components/UI/atoms";

const HomeCarousel = () => {
  const { loading, data, error } = useGetCarousel();

  const isReady = !loading && !error && data;

  return isReady ? (
    <Carousel slides={data.list} />
  ) : (
    <Skeleton height="300px" />
  );
};

export default withApolloProvider(HomeCarousel, {
  graphqlEndpoint: GRAPHQL_CMS_BASE_URL
});
